var _rect, _path, _g, _path2, _g2, _path3, _path4, _rect2, _rect3, _rect4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHieutIrregular = function SvgHieutIrregular(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 20,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 40,
    width: 53,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2272 40.3628C21.7519 40.3628 10 43.1943 10 46.6825C10 47.5567 10.7374 48.3894 12.0663 49.1446C16.0585 46.8748 25.378 45.2825 36.2272 45.2825C47.0764 45.2825 56.3959 46.8748 60.3873 49.1446C61.7165 48.3894 62.454 47.5567 62.454 46.6825C62.454 43.1943 50.702 40.3628 36.2272 40.3628Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2272 40.3628C21.7519 40.3628 10 43.1943 10 46.6825C10 47.5567 10.7374 48.3894 12.0663 49.1446C16.0585 46.8748 25.378 45.2825 36.2272 45.2825C47.0764 45.2825 56.3959 46.8748 60.3873 49.1446C61.7165 48.3894 62.454 47.5567 62.454 46.6825C62.454 43.1943 50.702 40.3628 36.2272 40.3628Z",
    fill: "url(#paint0_linear)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 45,
    width: 49,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0654 45.2845H60.3864V53.0001H12.0654V45.2845Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0654 49.1429C16.0572 46.875 25.3771 45.2845 36.2259 45.2845C47.0755 45.2845 56.3946 46.875 60.3864 49.1429C56.3946 51.4123 47.0755 53.0002 36.2259 53.0002C25.3771 53.0002 16.0572 51.4123 12.0654 49.1429Z",
    fill: "#C8C8C8"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3374 20.6847C33.0755 20.857 32.1922 22.0196 32.3645 23.2815L32.5189 24.4125C32.5936 24.9597 32.2106 25.4638 31.6634 25.5385L25.2455 26.4148C23.7854 26.6141 22.7633 27.9595 22.9626 29.4197C23.162 30.8798 24.5073 31.9019 25.9675 31.7026L45.3561 29.0554C46.8163 28.8561 47.8384 27.5107 47.639 26.0506C47.4397 24.5904 46.0943 23.5683 44.6342 23.7676L38.2147 24.6441C37.6675 24.7188 37.1633 24.3358 37.0886 23.7886L36.9342 22.6576C36.7619 21.3957 35.5993 20.5124 34.3374 20.6847Z",
    fill: "#DF6D65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5074 47.1837C43.1048 46.4195 47.2114 42.6434 46.6798 38.7496C46.1482 34.8558 41.1796 32.3187 35.5822 33.0829C29.9848 33.8472 25.8782 37.6232 26.4099 41.5171C26.9415 45.4109 31.91 47.948 37.5074 47.1837ZM36.8193 42.1477C38.8814 41.8661 40.4301 40.736 40.2782 39.6235C40.1263 38.511 38.3314 37.8373 36.2692 38.1189C34.207 38.4004 32.6584 39.5306 32.8103 40.6431C32.9622 41.7556 34.7571 42.4292 36.8193 42.1477Z",
    fill: "#DF6D65"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 8,
    width: 1,
    height: 9,
    rx: 0.5,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 9,
    width: 1,
    height: 14,
    rx: 0.5,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 9,
    width: 1,
    height: 12,
    rx: 0.5,
    fill: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 32.6402,
    y1: 51.4831,
    x2: 38.5844,
    y2: 32.5574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606060"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHieutIrregular);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/hieut-irregular.845c4d67bec44d83c9af03eb072d61d6.blank.svg";